import React, { useState } from 'react';
import { distinct } from 'utils';
import CitiesList from './DropDownList/CitiesList';
import DropDownList from './DropDownList/DropDownList';

import * as styles from './SideMenu.module.scss';

function SideMenu({ offices }) {
  const countries = distinct(offices.map(office => office.country));
  const officesGroupedByCountry = countries.map(country => ({
    country,
    offices: offices.filter(office => office.country === country),
  }));

  const [activeCountry, setActiveCountry] = useState(null);

  const toggleDropdown = country => () => {
    if (country === activeCountry) {
      setActiveCountry(null);
    } else {
      setActiveCountry(country);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        {officesGroupedByCountry.map((item, index) => {
          return (
            <DropDownList
              key={index}
              title={item.country}
              isOpened={activeCountry === item.country}
              toggleListHandler={toggleDropdown(item.country)}
            >
              <CitiesList offices={item.offices} />
            </DropDownList>
          );
        })}
      </div>
    </div>
  );
}

export default SideMenu;
